import React from "react";
import HeaderBread from "../../../components/HeaderBread";
import Layout from "../../../Layout";
import CustomHeaderTitle from "../../../components/constants/CustomHeaderTitle";
import PopupInput from "../../../components/PopupInput/PopupInput";

const CreatePopup = () => {
  const navigation = [
    { title: "Home", route: "/" },
    { title: "Popup List", route: "/website/webpages/popup" },
    { title: "Add Popup", route: "/website/webpages/popup/add" },
  ];

  return (
    <Layout type={"create_per"} module_data={"Popup"}>
      <CustomHeaderTitle title={"Create Popup"} />
      <HeaderBread navigation={navigation} title={"Add Popup"} />
      <PopupInput popup={{}} />
    </Layout>
  );
};

export default CreatePopup;
